const options = [
  {
    key: 'mailbox',
    label: 'MailBox',
    leftIcon: 'ion-email'
  }
];
export default options;
